import { getElements, ifSelectorExist } from "./utils-child";

export const openAllAccordions = () => {
  const accordions = getElements(".accordion-faq-item");
  if (accordions.length != 0) {
    accordions.forEach((accordion) => {
      const content = accordion.querySelector(".accordion-faq-item-content");
      accordion.classList.add("active");
      content.style.maxHeight = content.scrollHeight + "px";
    });
  };
};

export const openFirstAccordion = () => {
  const accordions = getElements(".accordion-faq-item");
  if (accordions.length != 0) {
    const content = accordions[0].querySelector(".accordion-faq-item-content");
    accordions[0].classList.add("active");
    content.style.maxHeight = content.scrollHeight + "px";
  };
};
